import { SelectClient } from '../SelectClient'

const ReceiptSelectClient: React.FC = () => {
  return <SelectClient selectNewClient={true} />
}

export default ReceiptSelectClient
